module.exports = __webpack_public_path__ + "img/blog-24.102bc65b.webp";